import React from "react";
import { CustomDropdown } from "../ui/dropdown/CustomDropdown";
import { CustomDropdownButton } from "../ui/dropdown/CustomDropdownButton";
import { CustomDropdownMenu } from "../ui/dropdown/CustomDropdownMenu";
import { CustomDropdownMenuList } from "../ui/dropdown/CustomDropdownMenuList";

const UpperTabs = React.memo(
  ({
    activeTab,
    setActiveTab,
    upparTabs,
    totalEmp,
    userData,
    onInnerChange = () => {},
    DepartmentIcons = {},
    isAllFilterShow = true,
    upparTabsLimite = 4,
    UpparAllIcon = null,
  }) => {

const MAX_SHORTCUTS = upparTabsLimite || 4;

// separate filters
const dateFilters = upparTabs?.filter(
  (tab) => tab?.type === "api_call"

);

const otherFilters = upparTabs?.filter(
  (tab) => tab?.type !== "api_call"

);

// prioritize other filters by total count
const sortedOtherFilters = [...otherFilters].sort(
  (a, b) => (b.total || 0) - (a.total || 0)
);

// calculate remaining slots
const remainingSlots = Math.max(
  0,
  MAX_SHORTCUTS - sortedOtherFilters.length
);

// final tabs
const finalTabs = [
  ...sortedOtherFilters,
  // ...dateFilters.slice(0, remainingSlots),
];
    
    return (
      <div className="flex items-center gap-2 mb-[-10px]">
        {isAllFilterShow ? (
          <div
            className="flex items-center gap-1 py-[6px] cursor-pointer bg-[white] border border-[white] px-[14px] rounded-[8px]"
            onClick={() => {
              setActiveTab(null);
            }}
            style={activeTab == null ? { borderColor: "#335CFF" } : {}}
          >
            <span className="w-fit h-fit flex-shrink-0">
              {UpparAllIcon ? (
                <UpparAllIcon />
              ) : (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    opacity="0.4"
                    d="M8.2499 10.5C8.2499 8.42893 9.92884 6.75 11.9999 6.75C14.071 6.75 15.7499 8.42893 15.7499 10.5C15.7499 12.0256 14.8388 13.3385 13.5311 13.9242C16.2049 14.5465 18.25 16.7615 18.25 19.499C18.25 19.9133 17.9142 20.249 17.5 20.249H6.5C6.08579 20.249 5.75 19.9133 5.75 19.499C5.75 16.7615 7.79507 14.5466 10.4688 13.9242C9.16099 13.3385 8.2499 12.0257 8.2499 10.5Z"
                    fill="#141B34"
                  />
                  <path
                    d="M7.4999 3.74805C5.42884 3.74805 3.7499 5.42698 3.7499 7.49805C3.7499 9.02371 4.66099 10.3366 5.96877 10.9222C3.29507 11.5447 1.25 13.7596 1.25 16.4971C1.25 16.9113 1.58579 17.2471 2 17.2471H4.62528C5.17244 15.6666 6.27833 14.3603 7.67909 13.4807C7.09348 12.6342 6.7499 11.6067 6.7499 10.498C6.7499 8.0732 8.39385 6.03231 10.628 5.42911C9.95662 4.41605 8.80627 3.74805 7.4999 3.74805Z"
                    fill="#141B34"
                  />
                  <path
                    d="M19.375 17.2471C18.8279 15.6665 17.7219 14.3602 16.3211 13.4806C16.9067 12.6341 17.2502 11.6066 17.2502 10.498C17.2502 8.0732 15.6063 6.03231 13.3721 5.42911C14.0435 4.41605 15.1939 3.74805 16.5002 3.74805C18.5713 3.74805 20.2502 5.42698 20.2502 7.49805C20.2502 9.02368 19.3392 10.3365 18.0314 10.9222C20.7052 11.5446 22.7503 13.7595 22.7503 16.4971C22.7503 16.9113 22.4145 17.2471 22.0003 17.2471H19.375Z"
                    fill="#141B34"
                  />
                </svg>
              )}
            </span>
            <span className="text-sm">All</span>
            <span className="py-[2px] text-xs px-[5px] bg-[#D9D9D9] rounded">
              {totalEmp || userData?.length}
            </span>
          </div>
        ) : null}
        {finalTabs?.slice(0, MAX_SHORTCUTS)?.map((eachTab, index) => {
          const IconComponent = DepartmentIcons[eachTab?.value];

          return (
            <div
              key={index}
              className="flex items-center gap-1 py-[6px] cursor-pointer bg-[white] border border-[white] px-[14px] rounded-[8px]"
              onClick={() => {
                setActiveTab(
                  { value: eachTab?.value, header_key: eachTab?.header_key },
                  eachTab,
                );
              }}
              style={
                `${eachTab?.header_key}-${eachTab?.value}` ==
                `${activeTab?.header_key}-${activeTab?.value}`
                  ? { borderColor: "#335CFF" }
                  : {}
              }
            >
              <span className="w-fit h-fit flex-shrink-0">
                {IconComponent ? (
                  <IconComponent />
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      opacity="0.4"
                      d="M8.2499 10.5C8.2499 8.42893 9.92884 6.75 11.9999 6.75C14.071 6.75 15.7499 8.42893 15.7499 10.5C15.7499 12.0256 14.8388 13.3385 13.5311 13.9242C16.2049 14.5465 18.25 16.7615 18.25 19.499C18.25 19.9133 17.9142 20.249 17.5 20.249H6.5C6.08579 20.249 5.75 19.9133 5.75 19.499C5.75 16.7615 7.79507 14.5466 10.4688 13.9242C9.16099 13.3385 8.2499 12.0257 8.2499 10.5Z"
                      fill="#141B34"
                    />
                    <path
                      d="M7.4999 3.74805C5.42884 3.74805 3.7499 5.42698 3.7499 7.49805C3.7499 9.02371 4.66099 10.3366 5.96877 10.9222C3.29507 11.5447 1.25 13.7596 1.25 16.4971C1.25 16.9113 1.58579 17.2471 2 17.2471H4.62528C5.17244 15.6666 6.27833 14.3603 7.67909 13.4807C7.09348 12.6342 6.7499 11.6067 6.7499 10.498C6.7499 8.0732 8.39385 6.03231 10.628 5.42911C9.95662 4.41605 8.80627 3.74805 7.4999 3.74805Z"
                      fill="#141B34"
                    />
                    <path
                      d="M19.375 17.2471C18.8279 15.6665 17.7219 14.3602 16.3211 13.4806C16.9067 12.6341 17.2502 11.6066 17.2502 10.498C17.2502 8.0732 15.6063 6.03231 13.3721 5.42911C14.0435 4.41605 15.1939 3.74805 16.5002 3.74805C18.5713 3.74805 20.2502 5.42698 20.2502 7.49805C20.2502 9.02368 19.3392 10.3365 18.0314 10.9222C20.7052 11.5446 22.7503 13.7595 22.7503 16.4971C22.7503 16.9113 22.4145 17.2471 22.0003 17.2471H19.375Z"
                      fill="#141B34"
                    />
                  </svg>
                )}
              </span>
              <span className="text-sm truncate">{eachTab?.value}</span>
              {eachTab?.total && (
                <span className="py-[2px] text-xs px-[5px] bg-[#D9D9D9] rounded">
                  {eachTab?.total}
                </span>
              )}
            </div>
          );
        })}
        {finalTabs?.length > MAX_SHORTCUTS ? (
          <CustomDropdown position="bottom-left" className="myDropdown !h-full">
            <CustomDropdownButton
              arrow={true}
              className="flex !h-full items-center gap-1 py-[6px] cursor-pointer bg-[white] border border-[white] px-[14px] rounded-[8px]"
            >
              <span className="text-[14px] truncate">More</span>
            </CustomDropdownButton>

            <CustomDropdownMenu>
              {finalTabs?.slice(MAX_SHORTCUTS)?.map((eachTab, i) => {
                const IconComponent = DepartmentIcons[eachTab?.value];
                return (
                  <CustomDropdownMenuList
                    key={i}
                    className={` ${!(finalTabs?.slice(MAX_SHORTCUTS)?.length - 1 ==  i) ? "border-b  border-gray-200 " : null  }`}
                    onClick={() => {
                      onInnerChange(eachTab, i + 3);
                    }}
                  >
                    <div className="flex items-center gap-1">
                      <span>
                        {IconComponent ? (
                          <IconComponent />
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <path
                              opacity="0.4"
                              d="M8.2499 10.5C8.2499 8.42893 9.92884 6.75 11.9999 6.75C14.071 6.75 15.7499 8.42893 15.7499 10.5C15.7499 12.0256 14.8388 13.3385 13.5311 13.9242C16.2049 14.5465 18.25 16.7615 18.25 19.499C18.25 19.9133 17.9142 20.249 17.5 20.249H6.5C6.08579 20.249 5.75 19.9133 5.75 19.499C5.75 16.7615 7.79507 14.5466 10.4688 13.9242C9.16099 13.3385 8.2499 12.0257 8.2499 10.5Z"
                              fill="#141B34"
                            />
                            <path
                              d="M7.4999 3.74805C5.42884 3.74805 3.7499 5.42698 3.7499 7.49805C3.7499 9.02371 4.66099 10.3366 5.96877 10.9222C3.29507 11.5447 1.25 13.7596 1.25 16.4971C1.25 16.9113 1.58579 17.2471 2 17.2471H4.62528C5.17244 15.6666 6.27833 14.3603 7.67909 13.4807C7.09348 12.6342 6.7499 11.6067 6.7499 10.498C6.7499 8.0732 8.39385 6.03231 10.628 5.42911C9.95662 4.41605 8.80627 3.74805 7.4999 3.74805Z"
                              fill="#141B34"
                            />
                            <path
                              d="M19.375 17.2471C18.8279 15.6665 17.7219 14.3602 16.3211 13.4806C16.9067 12.6341 17.2502 11.6066 17.2502 10.498C17.2502 8.0732 15.6063 6.03231 13.3721 5.42911C14.0435 4.41605 15.1939 3.74805 16.5002 3.74805C18.5713 3.74805 20.2502 5.42698 20.2502 7.49805C20.2502 9.02368 19.3392 10.3365 18.0314 10.9222C20.7052 11.5446 22.7503 13.7595 22.7503 16.4971C22.7503 16.9113 22.4145 17.2471 22.0003 17.2471H19.375Z"
                              fill="#141B34"
                            />
                          </svg>
                        )}
                      </span>
                      <span>{eachTab?.value}</span>
                      {eachTab?.total && (
                        <span className="py-[2px] text-[12px] px-[5px] bg-[#D9D9D9] rounded">
                          {eachTab?.total}
                        </span>
                      )}
                    </div>
                  </CustomDropdownMenuList>
                );
              })}
              {/* <CustomDropdownMenuList>
                            <span>Number List</span>
                        </CustomDropdownMenuList> */}
            </CustomDropdownMenu>
          </CustomDropdown>
        ) : null}
      </div>
    );
  },
);

export default UpperTabs;
